/**
 * Гард против «тихой 200» (KAN-311): бэкенд местами возвращает
 * `Ok(OperationResultDto { Success = false })` — HTTP 200, но операция провалена.
 * Центральный axios-пайплайн видит только HTTP-статус, поэтому такой провал
 * невидим, если call-site забыл проверить `result.success`.
 *
 * Детект строгий: объект ТОЛЬКО с ключами из формы OperationResultDto
 * (success/message/error/errorCode) и success === false. Ответы с полезной
 * нагрузкой (updatedNotification и т.п.) не трогаем — там `success` может быть
 * легитимной бизнес-семантикой, обрабатываемой на месте.
 */

const OPERATION_RESULT_KEYS = new Set(["success", "message", "error", "errorCode"]);

export const OPERATION_FAILED_CODE = "OPERATION_FAILED";

export function isOperationResultFailure(
  data: unknown,
): data is { success: false; message?: string; error?: string } {
  if (typeof data !== "object" || data === null || Array.isArray(data)) return false;
  const rec = data as Record<string, unknown>;
  if (rec["success"] !== false) return false;
  return Object.keys(rec).every((key) => OPERATION_RESULT_KEYS.has(key));
}

export function extractOperationFailureMessage(data: {
  message?: string;
  error?: string;
}): string | undefined {
  const msg = data.message ?? data.error;
  return typeof msg === "string" && msg.trim().length > 0 ? msg.trim() : undefined;
}
